import { Button, Col, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import 'moment/locale/ko';
import styled from 'styled-components';
import { BidProposal } from '../../modules/bid-chances';
import { priceToString } from '../../util/utils';
import { styledTable } from '../styled/mixin';
import {
  DownloadOutlined,
  EyeOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { Bidder, BidderStatus } from '../../modules/bidders';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidProposalListComponentProps {
  // bidProposals: BidProposal[];
  bidder: Bidder;
  isSovIncluded: boolean;
  moveToBidProposalDetailPage: (bidProposalId: number) => void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  openBidProposalCreateModal: () => void;
  openImagePreview: (imageData: any) => void;
}

function BidProposalListComponent({
  // bidProposals,
  bidder,
  isSovIncluded,
  moveToBidProposalDetailPage,
  downloadFile,
  openBidProposalCreateModal,
  openImagePreview,
}: BidProposalListComponentProps) {
  const columns: ColumnsType<BidProposal> = [
    // {
    //   title: '업체명',
    //   dataIndex: ['user', 'myEnterprise', 'name'],
    // },
    // {
    //   title: '제출자명',
    //   render: (text: any, record: any, index: any) =>
    //     record.user === null
    //       ? `${record.userData.name}(${phoneFormatter(
    //           record.userData.personalPhone,
    //           1,
    //         )})`
    //       : `${record.user.name}(${phoneFormatter(
    //           record.user.personalPhone,
    //           1,
    //         )})`,
    // },
    {
      title: '금액',
      dataIndex: 'amount',
      width: '20%',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
    {
      title: '제출일시',
      dataIndex: 'createdAt',
      width: '25%',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '상세내역',
      width: '60%',
      render: (text: any, record: any, index: any) => {
        let children: any = [];
        for (const _file of record.file) {
          children.push(
            <Row justify={'space-between'} key={_file.id}>
              <Space>
                <PaperClipOutlined rev={undefined} />
                <span>{_file.name}</span>
              </Space>
              <Space>
                <Button
                  size="small"
                  icon={<DownloadOutlined rev={undefined} />}
                  onClick={() => downloadFile(_file.id, _file.name)}
                >
                  {/* 다운로드 */}
                </Button>
                <Button
                  size="small"
                  icon={<EyeOutlined rev={undefined} />}
                  disabled={
                    _file.name.split('.').pop() !== 'jpg' &&
                    _file.name.split('.').pop() !== 'jpeg' &&
                    _file.name.split('.').pop() !== 'png' &&
                    _file.name.split('.').pop() !== 'pdf'
                  }
                  onClick={() => {
                    openImagePreview(_file);
                  }}
                >
                  {/* 미리보기 */}
                </Button>
              </Space>
            </Row>,
          );
        }
        return <>{children}</>;
      },
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h3>제출 금액</h3>
        </Col>
        <Col>
          <Button
            size="small"
            onClick={openBidProposalCreateModal}
            disabled={bidder.status === BidderStatus.AWARDED}
          >
            대신 제출
          </Button>
        </Col>
      </Row>
      <Table<BidProposal>
        rowKey="id"
        columns={columns}
        dataSource={bidder.bidChance?.bidProposals}
        pagination={false}
      />
    </StyledDiv>
  );
}

export default BidProposalListComponent;
